module.exports = __webpack_public_path__ + "assets/img/5_1359_big.0ac8f635.jpg";